import { render } from "./ydForm.vue?vue&type=template&id=0e0bb265"
import script from "./ydForm.vue?vue&type=script&lang=js"
export * from "./ydForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__